import { EventBus } from '@klarna-web-sdk/utils';
export var messagingEvents;
(function (messagingEvents) {
    messagingEvents["MODAL_OPENED_LEGACY"] = "informationalModalOpened";
    messagingEvents["MODAL_CLOSED_LEGACY"] = "informationalModalClosed";
    messagingEvents["PLACEMENT_RENDERED_LEGACY"] = "placementRendered";
    messagingEvents["PLACEMENT_RENDERED"] = "placement-rendered";
    messagingEvents["MODAL_OPENED"] = "informational-modal-opened";
    messagingEvents["MODAL_CLOSED"] = "informational-modal-closed";
})(messagingEvents || (messagingEvents = {}));
export class MessagingEvents extends EventBus {
    constructor() {
        super();
    }
    static getInstance() {
        if (!MessagingEvents.instance) {
            MessagingEvents.instance = new MessagingEvents();
        }
        return MessagingEvents.instance;
    }
}
export default messagingEvents;
